import { gql } from '@apollo/client';

export const deleteTariffForExtend = gql`
  mutation deleteTariffForExtend($input: DeleteTariffInput!) {
    deleteTariff(input: $input)
  }
`;
